/**
 * @file 充电桩管理
 */

import request from '@/utils/request'

/**
 * @typedef {Object} ChargePile 充电桩对象
 * @property {string|number} [id] 充电桩Id
 * @property {string|number} stationId 电站Id
 * @property {string} uuid UUID
 * @property {string} [devId] 设备ID（设备编码）
 * @property {string} chargePileName 充电桩名称
 * @property {string} [factoryName] 厂家名称
 * @property {string} [productModel] 产品型号
 * @property {string|number} [parentEquipmentId] 关联设备ID
 * @property {string} [inputVoltage] 输入电压(V)
 * @property {string} [outputVoltage] 输出电压(V)
 * @property {string} [ratedOutputPower] 额定输出功率(kW)
 * @property {string} [fullLoadPower] 满载功率因数
 * @property {string} [chargeInterface] 充电接口类型
 * @property {number} [chargeMode] 充电模式 (1:快充 2:慢充)
 * @property {number} [sort] 排序号
 */

/**
 * 修改充电桩
 * @param {ChargePile} chargePile
 */
export function updateChargePile(chargePile) {
  return request({
    url: '/device/v3/charge/pile',
    method: 'put',
    data: chargePile
  })
}


/**
 * 新增充电桩
 * @param {ChargePile} chargePile
 */
export function addChargePile(chargePile) {
  return request({
    url: '/device/v3/charge/pile',
    method: 'post',
    data: chargePile
  })
}


/**
 * 获取充电桩列表
 * @param {object} params
 * @param {string} params.stationId
 * @param {string} [params.chargePileName]
 * @param {string} [params.productModel]
 * @param {string} [params.pageNum]
 * @param {string} [params.pageSize]
 * @returns
 */
export function getChargePileList(params) {
  return request({
    url: '/device/v3/charge/pile/list',
    method: 'get',
    params: params
  })
}


/**
 * 批量删除充电桩
 * @param {string|number} ids 充电桩Id
 * @returns
 */
export function delChargePileList(ids) {
  if (Array.isArray(ids)) {
    ids = ids.join(',')
  }
  return request({
    url: `/device/v3/charge/pile/${ids}`,
    method: 'delete',
  })
}


/**
 * 获取充电桩详细信息
 * @param {string|number} id 充电桩Id
 */
export function getChargePile(id) {
  return request({
    url: `/device/v3/charge/pile/${id}`,
    method: 'get',
  })
}

// 充电桩实时数据
///////////////////////////////////////////////////////////////////////////////////


/**
 * 充电桩设备模型（点表）
 * @param {string|number} stationId 电站Id
 * @returns
 */
export function getChargePileDataModel(stationId) {
  return request({
    url: `/dashboard/charge/pile/data/model/${stationId}`,
    method: 'get',
  })
}


/**
 * 充电桩设备实时数据
 * @param {string|number} stationId 电站Id
 * @returns
 */
export function getChargePileDataRealtime(stationId) {
  return request({
    url: `/dashboard/charge/pile/data/realtime/${stationId}`,
    method: 'get',
  })
}

/**
 * 折线图数据
 * @param {string|number} stationId 电站Id
 * @returns
 */
export function getChargePileDataStatistics(stationId) {
  return request({
    url: `/dashboard/charge/pile/data/model/${stationId}`,
    method: 'get',
  })
}
